// Telling the console that something was written (F-HQ-03). Guided setup's steps are worked out by the server from the
// venue's state (hours, passes, stations, tax, printers, payments...), so any successful write may tick one, and writes
// are made in many ways: a mutation hook, a settings form's own save, a dialog calling the client. The one place they
// all pass through is the client's `fetch`, so it is wrapped here: every accepted write (anything but GET and HEAD)
// calls the listeners, and the console re-reads what depends on server state (`ConsoleApp`).

import type { FetchLike } from '@clavian/api-client';

const listeners = new Set<() => void>();

/** Be told after each successful write the console's client made. Returns the way to stop. */
export function onWriteSucceeded(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** The same `fetch`, announcing every write that was accepted. */
export function announceWrites(inner: FetchLike): FetchLike {
  return async (input, init) => {
    const response = await inner(input, init);
    if (response.ok && init.method !== 'GET' && init.method !== 'HEAD') for (const listener of [...listeners]) listener();
    return response;
  };
}
